/**
 * Getters for css used when opening a print window needed because the css wont be carried over to the new window
 */
export class PrintStyling {

    /**
     * getter to get css when printing result from imported xml files
     */
    getDigitalImportExportCss() {
        let styling = " \
        .table-bordered thead th, \
        .table-bordered thead td { \
            border-bottom-width: 2px; \
        } \
        .table thead th { \
            vertical-align: bottom;border-bottom: 2px solid #dee2e6; \
        } \
        .table-bordered th, .table-bordered td { \
            border: 1px solid #dee2e6; \
        } \
        .table th, \
        .table td { \
            padding: 0.75rem; \
        } \
        .th { \
            text-align: inherit; display: table-cell; font-weight: bold; \
        } \
        .table { \
            width: 100%; margin-bottom: 1rem; \
            color: #212529; \
            border-collapse: collapse; \
            text-indent: initial; \
            border-spacing: 2px; \
        } \
        body { \
            font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; \
            font-size: 1rem; \
            font-weight: 400; \
            line-height: 1.5; \
            color: #212529; \
            text-align: left; \
        } \
        /*!*  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome*  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)*//* FONT PATH* -------------------------- */ \
        @font-face { \
            font-family: 'FontAwesome'; \
            src: url('fontawesome-webfont.eot?v=4.7.0'); \
            src: url('fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'), url('fontawesome-webfont.woff2?v=4.7.0') format('woff2'), url('fontawesome-webfont.woff?v=4.7.0') format('woff'), url('fontawesome-webfont.ttf?v=4.7.0') format('truetype'), url('fontawesome-webfont.svg?v=4.7.0#fontawesomeregular') format('svg'); \
            font-weight: normal; \
            font-style: normal; \
        } \
        .fa { \
            display: inline-block; \
            font: normal normal normal 14px/1 FontAwesome; \
            font-size: inherit; \
            text-rendering: auto; \
            -webkit-font-smoothing: antialiased; \
            -moz-osx-font-smoothing: grayscale; \
        } \
        .fa-check:before { \
            content: \"\f00c\"; \
        } \
        .fa-remove:before, \
        .fa-close:before, \
        .fa-times:before { \
            content: \"\f00d\"; \
        } \
        "
        return styling;
    }
}